import { ExistingContract } from '@/components/listing/contract/Contract.interfaces';
import { fetcher } from '@/utils/http';
import { HttpMethod } from '@proprioo/hokkaido';

export const mergeCustomer = async (toUpdate: string, toReplace: string) =>
  await fetcher('/api/user/merge', {
    body: JSON.stringify({ toReplace, toUpdate }),
    method: HttpMethod.POST
  });

export const getExistingContracts = async (
  userIds: string[]
): Promise<ExistingContract[]> =>
  fetcher<ExistingContract[]>('/api/user/retrieveContracts', {
    body: JSON.stringify({ userIds }),
    method: HttpMethod.POST
  });

export const getFilteredContracts = (
  contracts: ExistingContract[]
): ExistingContract[] =>
  contracts.reduce((acc: ExistingContract[], item) => {
    const similarContractExist = acc.find(
      ({ documentType, listingId }) =>
        documentType === item.documentType && listingId === item.listingId
    );

    if (!similarContractExist) {
      acc.push(item);
    }

    return acc;
  }, []);
